import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { Home2Icon } from 'icons';
import { colors } from 'styles/colors';
import { HomeContainer } from './styles';

export function Home(): ReactElement {
  const { t } = useTranslation();
  return (
    <HomeContainer>
      <Home2Icon color={colors.icon['primary-base']} />
      <h1>{t('inicio')}</h1>
    </HomeContainer>
  );
}
